import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Autocomplete,
  Button,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  FormControl,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Switch,
  RadioGroup,
  Radio,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/system";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";

import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import { useApiManagerList } from "../../../../../hooks/api-manager";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import {
  escape,
  getUniqueDocumentServiceFields,
  unescape,
} from "../../../../../util/camundaPropertiesPanelUtils";
import GenericModal from "../../../../modal-closebtn/index";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

const FormControlStyled = styled(FormControl)(({ theme }) => ({
  width: "100%",
  marginTop: "2%",
}));

const AddIconStyled = styled(AddIcon)(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.main,
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const Title = styled(InputLabel)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,
  apiManagerList,
  handleChangeConfigFields,
  handleChangeAutoCompleteConfigFields,
  handleChangeConfigFieldsCheckbox,

  handleChangeApiVariables,
  addApiVariables,
  removeApiVariables,
  handleChangeAutoCompleteApiVariables,

  handleChangeApiHeaders,
  addApiHeaders,
  removeApiHeaders,
  handleChangeAutoCompleteApiHeaders,

  handleChangeApiQueryParams,
  addApiQueryParams,
  removeApiQueryParams,
  handleChangeAutoCompleteApiQueryParams,

  handleChangeApiFormData,
  addApiFormData,
  removeApiFormData,
  handleChangeAutoCompleteApiFormData,

  handleChangeApiResultToProcess,
  addApiResultToProcess,
  removeApiResultToProcess,
  handleChangeAutoCompleteApiResultToProcess,

  handleChangeApiManager,
  taskFields,
  businessObject,
}) {
  const apiManagerId = jsonConfig?.apiManagerId || "";
  const selectedApiManager = apiManagerList?.content?.find(
    (item) => String(item.id) === apiManagerId,
  );

  const selectedApiManagerUrl = selectedApiManager?.url || "";
  const selectedApiManagerHeadersKeys =
    (selectedApiManager?.headers && Object.keys(selectedApiManager.headers)) ||
    [];
  const selectedApiManagerQueryParamsKeys =
    (selectedApiManager?.queryParams &&
      Object.keys(selectedApiManager.queryParams)) ||
    [];
  const selectedApiManagerVariablesKeys =
    (selectedApiManager?.variables &&
      Object.keys(selectedApiManager.variables)) ||
    [];

  const selectedApiManagerFormDataKeys =
    (selectedApiManager?.bodyFormData?.length > 0 &&
      selectedApiManager.bodyFormData.map((field) => field?.name)) ||
    [];

  const url = jsonConfig?.url || "";
  const method = jsonConfig?.method || "";
  const headers = jsonConfig?.headers || [];
  const queryParams = jsonConfig?.queryParams || [];
  const bodyType = jsonConfig?.bodyType || "json";
  const body = jsonConfig?.body || "";
  const bodyFormData = jsonConfig?.bodyFormData || [];
  const resultType = jsonConfig?.resultType || "";

  const variables = jsonConfig?.variables || [];
  const apiResultToProcessVariable =
    jsonConfig?.apiResultToProcessVariable || [];

  const useCustomConfig = jsonConfig?.useCustomConfig || false;
  const apiResultId = jsonConfig?.apiResultId || "";

  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables
    .filter((value, index, self) => {
      return index === self.findIndex((obj) => obj.id === value.id);
    })
    .map((value) => value.id);

  const formFieldsVariables =
    taskFields?.filter(
      (taskField) =>
        !documentVariables.some((docItem) => docItem === taskField.id),
    ) || [];

  return (
    <>
      <Grid
        item
        size={12}
        style={{ height: "29px", marginBottom: "30px", marginTop: "20px" }}
      >
        <Typography variant="h6">{language.apiSelection}</Typography>
      </Grid>

      <Grid item size={12} style={{ marginRight: 0 }}>
        <TextField
          select
          label={language.api}
          fullWidth
          variant="outlined"
          id="apiManagerId"
          name="apiManagerId"
          inputProps={{
            id: "",
          }}
          value={String(apiManagerId)}
          onChange={handleChangeApiManager}
          renderValue={(value) => {
            if (!value) {
              return "";
            }
            const selectedItem =
              apiManagerList &&
              apiManagerList.content &&
              apiManagerList.content.find((item) => String(item.id) === value);
            return (
              <Typography variant="body1" color="primary">
                {selectedItem?.name}
              </Typography>
            );
          }}
        >
          {apiManagerList &&
            apiManagerList.content &&
            apiManagerList.content?.map((item) => {
              return (
                <MenuItem key={item.id} value={String(item.id)}>
                  {item.name}
                </MenuItem>
              );
            })}
        </TextField>
      </Grid>

      <Grid
        item
        size={12}
        style={{ height: "29px", marginBottom: "30px", marginTop: "45px" }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="h6">{language.apiInputParameters}</Typography>
          <AddIconStyled size="small" color="primary" onClick={addApiVariables}>
            <AddIcon />
          </AddIconStyled>
        </Stack>
      </Grid>

      <Grid
        item
        size={12}
        container
        spacing={3}
        style={{ marginBottom: "30px" }}
        wrap="wrap"
      >
        {variables && variables.length > 0 ? (
          <>
            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.apiVariable}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.processVariable}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.addRemove}
              </Typography>
            </Grid>
            {variables.map((s, index) => {
              return (
                <Fragment key={`s${index}_${s.document}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Autocomplete
                      value={variables[index]?.variableKey || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteApiVariables(
                          event,
                          value,
                          index,
                          "variableKey",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeApiVariables(event, index, "variableKey")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_variableKey"`}
                      name="variableKey"
                      options={selectedApiManagerVariablesKeys}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="variableKey"
                          required
                          label={language.apiVariable}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Autocomplete
                      value={variables[index]?.variableValue || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteApiVariables(
                          event,
                          value,
                          index,
                          "variableValue",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeApiVariables(event, index, "variableValue")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_variableValue`}
                      name="variableValue"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="variableValue"
                          required
                          label={language.processVariable}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <IconButton
                      size="small"
                      color="primary"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid",
                      }}
                      onClick={(event) => removeApiVariables(event, index)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Fragment>
              );
            })}
          </>
        ) : (
          <Grid
            item
            size={12}
            justifyContent="center"
            alignItems="center"
            style={{ display: "flex" }}
          >
            <Typography variant="body1" style={{ fontWeight: "400" }}>
              {language.noVariableSelected}
            </Typography>
          </Grid>
        )}
      </Grid>

      <Grid item container size={12} spacing={2} sx={{ marginY: 5 }}>
        <Grid item size={12}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="h6">{language.apiOutputParameters}</Typography>
            <AddIconStyled
              size="small"
              color="primary"
              onClick={addApiResultToProcess}
            >
              <AddIcon />
            </AddIconStyled>
          </Stack>
        </Grid>
        <Grid item size={12} container spacing={2} wrap="wrap">
          {apiResultToProcessVariable &&
          apiResultToProcessVariable.length > 0 ? (
            <>
              <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography variant="body1" style={{ fontWeight: "410" }}>
                  {language.apiResult}
                </Typography>
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography variant="body1" style={{ fontWeight: "410" }}>
                  {language.processVariable}
                </Typography>
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography variant="body1" style={{ fontWeight: "410" }}>
                  {language.addRemove}
                </Typography>
              </Grid>
              {apiResultToProcessVariable.map((s, index) => {
                return (
                  <Fragment key={`s${index}_${s.document}`}>
                    <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                      <Autocomplete
                        value={
                          apiResultToProcessVariable[index]?.apiResultKey || ""
                        }
                        onChange={(event, value) =>
                          handleChangeAutoCompleteApiResultToProcess(
                            event,
                            value,
                            index,
                            "apiResultKey",
                          )
                        }
                        onInputChange={(event) =>
                          handleChangeApiResultToProcess(
                            event,
                            index,
                            "apiResultKey",
                          )
                        }
                        selectOnFocus
                        freeSolo
                        id={`s${index}_apiResultKey"`}
                        name="apiResultKey"
                        options={[]}
                        getOptionLabel={(formField) => {
                          if (typeof formField === "string") {
                            return formField;
                          }
                          return formField?.id || "";
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            name="apiResultKey"
                            required
                            label={language.apiResult}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                      <Autocomplete
                        value={
                          apiResultToProcessVariable[index]?.apiResultValue ||
                          ""
                        }
                        onChange={(event, value) =>
                          handleChangeAutoCompleteApiResultToProcess(
                            event,
                            value,
                            index,
                            "apiResultValue",
                          )
                        }
                        onInputChange={(event) =>
                          handleChangeApiResultToProcess(
                            event,
                            index,
                            "apiResultValue",
                          )
                        }
                        selectOnFocus
                        freeSolo
                        id={`s${index}_apiResultValue`}
                        name="apiResultValue"
                        options={formFieldsVariables}
                        getOptionLabel={(formField) => {
                          if (typeof formField === "string") {
                            return formField;
                          }
                          return formField?.id || "";
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            name="apiResultValue"
                            required
                            label={language.processVariable}
                          />
                        )}
                      />
                    </Grid>

                    <Grid
                      item
                      size={{ xs: 12, sm: 6, md: 4 }}
                      justifyContent="center"
                      alignItems="center"
                      style={{ display: "flex" }}
                    >
                      <IconButton
                        size="small"
                        color="primary"
                        style={{
                          borderRadius: "8px",
                          border: "1px solid",
                        }}
                        onClick={(event) =>
                          removeApiResultToProcess(event, index)
                        }
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Grid>
                  </Fragment>
                );
              })}
            </>
          ) : (
            <Grid
              item
              size={12}
              justifyContent="center"
              alignItems="center"
              style={{ display: "flex" }}
            >
              <Typography variant="body1" style={{ fontWeight: "400" }}>
                {language.noResultSelected}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item size={12}>
        <Autocomplete
          value={apiResultId}
          onChange={(event, value) =>
            handleChangeAutoCompleteConfigFields(event, value, "apiResultId")
          }
          onInputChange={handleChangeConfigFields}
          selectOnFocus
          freeSolo
          id="apiResultId"
          name="apiResultId"
          options={formFieldsVariables}
          getOptionLabel={(formField) => {
            if (typeof formField === "string") {
              return formField;
            }
            return formField?.id || "";
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              name="apiResultId"
              required
              label={language.ID}
            />
          )}
        />
      </Grid>
      <Grid item size={12}>
        <FormControlLabel
          control={
            <Switch
              id="useCustomConfig"
              name="useCustomConfig"
              onChange={handleChangeConfigFieldsCheckbox}
              value={useCustomConfig}
              checked={useCustomConfig}
              size="medium"
            />
          }
          label={language.configureApi}
        />
      </Grid>

      {useCustomConfig && (
        <>
          <Grid container item size={12} spacing={3} wrap="wrap">
            <Grid item size={12}>
              <Autocomplete
                value={url}
                onChange={(event, value) =>
                  handleChangeAutoCompleteConfigFields(event, value, "url")
                }
                onInputChange={handleChangeConfigFields}
                selectOnFocus
                freeSolo
                id="url"
                name="url"
                options={[selectedApiManagerUrl]}
                getOptionLabel={(formField) => {
                  if (typeof formField === "string") {
                    return formField;
                  }
                  return formField?.id || "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    name="url"
                    required
                    label={language.url}
                    minRows={3}
                    multiline
                  />
                )}
              />
            </Grid>

            <Grid item size={12}>
              <Autocomplete
                value={method}
                onChange={(event, value) =>
                  handleChangeAutoCompleteConfigFields(event, value, "method")
                }
                onInputChange={handleChangeConfigFields}
                selectOnFocus
                freeSolo
                id="method"
                name="method"
                options={["GET", "POST", "DELETE", "PUT", "PATCH"]}
                getOptionLabel={(formField) => {
                  if (typeof formField === "string") {
                    return formField;
                  }
                  return formField?.id || "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    name="method"
                    required
                    label={language.httpMethod}
                  />
                )}
              />
            </Grid>
            <Grid item size={12}>
              <Autocomplete
                value={resultType}
                onChange={(event, value) =>
                  handleChangeAutoCompleteConfigFields(
                    event,
                    value,
                    "resultType",
                  )
                }
                onInputChange={handleChangeConfigFields}
                selectOnFocus
                freeSolo
                id="resultType"
                name="resultType"
                options={["FILE", "JSON", "XML", "TEXT"]}
                getOptionLabel={(formField) => {
                  if (typeof formField === "string") {
                    return formField;
                  }
                  return formField?.id || "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    name="resultType"
                    required
                    label={language.resultType}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid container item size={12} sx={{ marginY: 5 }}>
            <Grid item size={12}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography variant="h6">{language.headers}</Typography>
                <AddIconStyled
                  size="small"
                  color="primary"
                  onClick={addApiHeaders}
                >
                  <AddIcon />
                </AddIconStyled>
              </Stack>
            </Grid>

            <Grid item size={12} container spacing={3} wrap="wrap">
              {headers && headers.length > 0 ? (
                <>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1" style={{ fontWeight: "410" }}>
                      {language.headerName}
                    </Typography>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1" style={{ fontWeight: "410" }}>
                      {language.headerValue}
                    </Typography>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1" style={{ fontWeight: "410" }}>
                      {language.addRemove}
                    </Typography>
                  </Grid>
                  {headers.map((s, index) => {
                    return (
                      <Fragment key={`s${index}_${s.document}`}>
                        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                          <Autocomplete
                            value={headers[index]?.headerKey || ""}
                            onChange={(event, value) =>
                              handleChangeAutoCompleteApiHeaders(
                                event,
                                value,
                                index,
                                "headerKey",
                              )
                            }
                            onInputChange={(event) =>
                              handleChangeApiHeaders(event, index, "headerKey")
                            }
                            selectOnFocus
                            freeSolo
                            id={`s${index}_headerKey"`}
                            name="headerKey"
                            options={selectedApiManagerHeadersKeys}
                            getOptionLabel={(formField) => {
                              if (typeof formField === "string") {
                                return formField;
                              }
                              return formField?.id || "";
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="headerKey"
                                label={language.headerName}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                          <Autocomplete
                            value={headers[index]?.headerValue || ""}
                            onChange={(event, value) =>
                              handleChangeAutoCompleteApiHeaders(
                                event,
                                value,
                                index,
                                "headerValue",
                              )
                            }
                            onInputChange={(event) =>
                              handleChangeApiHeaders(
                                event,
                                index,
                                "headerValue",
                              )
                            }
                            selectOnFocus
                            freeSolo
                            id={`s${index}_headerValue`}
                            name="headerValue"
                            options={formFieldsVariables}
                            getOptionLabel={(formField) => {
                              if (typeof formField === "string") {
                                return formField;
                              }
                              return formField?.id || "";
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="headerValue"
                                label={language.headerValue}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                          <IconButton
                            size="small"
                            color="primary"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid",
                            }}
                            onClick={(event) => removeApiHeaders(event, index)}
                          >
                            <RemoveIcon />
                          </IconButton>
                        </Grid>
                      </Fragment>
                    );
                  })}
                </>
              ) : (
                <Grid
                  item
                  size={12}
                  justifyContent="center"
                  alignItems="center"
                  style={{ display: "flex" }}
                >
                  <Typography variant="body1" style={{ fontWeight: "400" }}>
                    {language.noHeaderSelected}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid container item size={12} sx={{ marginY: 5 }}>
            <Grid item size={12}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography variant="h6">{language.urlParameters}</Typography>
                <AddIconStyled
                  size="small"
                  color="primary"
                  onClick={addApiQueryParams}
                >
                  <AddIcon />
                </AddIconStyled>
              </Stack>
            </Grid>

            <Grid item size={12} container spacing={3} wrap="wrap">
              {queryParams && queryParams.length > 0 ? (
                <>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1" style={{ fontWeight: "410" }}>
                      {language.parameterName}
                    </Typography>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1" style={{ fontWeight: "410" }}>
                      {language.parameterValue}
                    </Typography>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1" style={{ fontWeight: "410" }}>
                      {language.addRemove}
                    </Typography>
                  </Grid>
                  {queryParams.map((s, index) => {
                    return (
                      <Fragment key={`s${index}_${s.document}`}>
                        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                          <Autocomplete
                            value={queryParams[index]?.queryParamKey || ""}
                            onChange={(event, value) =>
                              handleChangeAutoCompleteApiQueryParams(
                                event,
                                value,
                                index,
                                "queryParamKey",
                              )
                            }
                            onInputChange={(event) =>
                              handleChangeApiQueryParams(
                                event,
                                index,
                                "queryParamKey",
                              )
                            }
                            selectOnFocus
                            freeSolo
                            id={`s${index}_queryParamKey"`}
                            name="queryParamKey"
                            options={selectedApiManagerQueryParamsKeys}
                            getOptionLabel={(formField) => {
                              if (typeof formField === "string") {
                                return formField;
                              }
                              return formField?.id || "";
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="queryParamKey"
                                label={language.parameterName}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                          <Autocomplete
                            value={queryParams[index]?.queryParamValue || ""}
                            onChange={(event, value) =>
                              handleChangeAutoCompleteApiQueryParams(
                                event,
                                value,
                                index,
                                "queryParamValue",
                              )
                            }
                            onInputChange={(event) =>
                              handleChangeApiQueryParams(
                                event,
                                index,
                                "queryParamValue",
                              )
                            }
                            selectOnFocus
                            freeSolo
                            id={`s${index}_queryParamValue`}
                            name="queryParamValue"
                            options={formFieldsVariables}
                            getOptionLabel={(formField) => {
                              if (typeof formField === "string") {
                                return formField;
                              }
                              return formField?.id || "";
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="queryParamValue"
                                label={language.parameterValue}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                          <IconButton
                            size="small"
                            color="primary"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid",
                            }}
                            onClick={(event) =>
                              removeApiQueryParams(event, index)
                            }
                          >
                            <RemoveIcon />
                          </IconButton>
                        </Grid>
                      </Fragment>
                    );
                  })}
                </>
              ) : (
                <Grid
                  item
                  size={12}
                  justifyContent="center"
                  alignItems="center"
                  style={{ display: "flex" }}
                >
                  <Typography variant="body1" style={{ fontWeight: "400" }}>
                    {language.noUrlParameterSelected}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid item size={12} container>
            <Grid size={12}>
              <RadioGroup
                row
                name="bodyType"
                value={bodyType}
                onChange={handleChangeConfigFields}
              >
                <FormControlLabel
                  value="json"
                  control={<Radio />}
                  label={<Typography variant="h6">Body (JSON)</Typography>}
                  labelPlacement="end"
                />
                <FormControlLabel
                  value="formdata"
                  control={<Radio />}
                  label={<Typography variant="h6">Form-data</Typography>}
                  labelPlacement="end"
                />
              </RadioGroup>
            </Grid>
            {bodyType === "json" && (
              <Grid item size={12}>
                <FormControlStyled margin="normal">
                  <TextField
                    id="body"
                    name="body"
                    label={language.body}
                    value={body}
                    onChange={handleChangeConfigFields}
                    variant="outlined"
                    minRows={5}
                    multiline
                    fullWidth
                  />
                </FormControlStyled>
              </Grid>
            )}
            {bodyType === "formdata" && (
              <Grid
                size={12}
                container
                spacing={2}
                style={{ marginBottom: "30px" }}
                wrap="wrap"
              >
                {bodyFormData && bodyFormData.length > 0 ? (
                  <Grid
                    size={12}
                    container
                    spacing={2}
                    style={{ marginBottom: "30px" }}
                    wrap="wrap"
                  >
                    <Grid
                      item
                      size={{ xs: 12, sm: 6, md: 4 }}
                      justifyContent="center"
                      alignItems="center"
                      style={{ display: "flex" }}
                    >
                      <Typography variant="body1" style={{ fontWeight: "410" }}>
                        {language.fieldName}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      size={{ xs: 12, sm: 6, md: 4 }}
                      justifyContent="center"
                      alignItems="center"
                      style={{ display: "flex" }}
                    >
                      <Typography variant="body1" style={{ fontWeight: "410" }}>
                        {language.fieldValue}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      size={{ xs: 12, sm: 6, md: 2 }}
                      justifyContent="center"
                      alignItems="center"
                      style={{ display: "flex" }}
                    >
                      <Typography variant="body1" style={{ fontWeight: "410" }}>
                        {language.fieldType}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      size={{ xs: 12, sm: 6, md: 2 }}
                      justifyContent="center"
                      alignItems="center"
                      style={{ display: "flex" }}
                    >
                      <Typography variant="body1" style={{ fontWeight: "410" }}>
                        {language.addRemove}
                      </Typography>
                    </Grid>
                    {bodyFormData.map((s, index) => {
                      return (
                        <Fragment key={`s${index}_${s.document}`}>
                          <Grid
                            key={`s${index}_${s.document}`}
                            item
                            size={{ xs: 12, sm: 6, md: 4 }}
                          >
                            <Autocomplete
                              value={bodyFormData[index]?.name || ""}
                              onChange={(event, value) =>
                                handleChangeAutoCompleteApiFormData(
                                  event,
                                  value,
                                  index,
                                  "name",
                                )
                              }
                              onInputChange={(event) =>
                                handleChangeApiFormData(event, index, "name")
                              }
                              selectOnFocus
                              freeSolo
                              id={`s${index}_name"`}
                              name="name"
                              options={selectedApiManagerFormDataKeys}
                              getOptionLabel={(formField) => {
                                if (typeof formField === "string") {
                                  return formField;
                                }
                                return formField?.id || "";
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="name"
                                  label={language.fieldName}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                            <Autocomplete
                              value={bodyFormData[index]?.value || ""}
                              onChange={(event, value) =>
                                handleChangeAutoCompleteApiFormData(
                                  event,
                                  value,
                                  index,
                                  "value",
                                )
                              }
                              onInputChange={(event) =>
                                handleChangeApiFormData(event, index, "value")
                              }
                              selectOnFocus
                              freeSolo
                              id={`s${index}_value`}
                              name="value"
                              options={formFieldsVariables}
                              getOptionLabel={(formField) => {
                                if (typeof formField === "string") {
                                  return formField;
                                }
                                return formField?.id || "";
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="value"
                                  label={language.fieldValue}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
                            <Autocomplete
                              value={bodyFormData[index]?.type || ""}
                              onChange={(event, value) =>
                                handleChangeAutoCompleteApiFormData(
                                  event,
                                  value,
                                  index,
                                  "type",
                                )
                              }
                              onInputChange={(event) =>
                                handleChangeApiFormData(event, index, "type")
                              }
                              selectOnFocus
                              freeSolo
                              id={`s${index}_type`}
                              name="type"
                              options={["FILE", "JSON", "TEXT"]}
                              getOptionLabel={(formField) => {
                                if (typeof formField === "string") {
                                  return formField;
                                }
                                return formField?.id || "";
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="type"
                                  label={language.fieldType}
                                />
                              )}
                            />
                          </Grid>

                          <Grid
                            item
                            size={{ xs: 12, sm: 6, md: 2 }}
                            justifyContent="center"
                            alignItems="center"
                            style={{ display: "flex" }}
                          >
                            <IconButton
                              size="small"
                              color="primary"
                              style={{
                                borderRadius: "8px",
                                border: "1px solid",
                              }}
                              onClick={(event) =>
                                removeApiFormData(event, index)
                              }
                            >
                              <RemoveIcon />
                            </IconButton>
                          </Grid>
                        </Fragment>
                      );
                    })}
                  </Grid>
                ) : (
                  <Grid
                    item
                    size={12}
                    justifyContent="center"
                    alignItems="center"
                    style={{ display: "flex" }}
                  >
                    <Typography variant="body1" style={{ fontWeight: "400" }}>
                      {language.noFormDataSelected}
                    </Typography>
                  </Grid>
                )}
                <Grid item size={{ xs: 12, sm: 6, md: 10 }}></Grid>
                <Grid
                  item
                  size={{ xs: 12, sm: 6, md: 2 }}
                  justifyContent="center"
                  alignItems="center"
                  style={{ display: "flex" }}
                >
                  <AddIconStyled
                    size="small"
                    color="primary"
                    onClick={addApiFormData}
                  >
                    <AddIcon />
                  </AddIconStyled>
                </Grid>
              </Grid>
            )}
          </Grid>
        </>
      )}
    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerIntegrarApiManager({
  saveIntegrarApiManagerConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
}) {
  const [jsonConfig, setJsonConfig] = useState({
    url: "",
    method: "",
    apiManagerId: "",
    body: "",
    headers: [],
    queryParams: [],
    variables: [],
    apiResultId: "api_result",
    apiResultToProcessVariable: [],
    useCustomConfig: false,
  });

  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "lg",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);

  const { data: apiManagerList } = useApiManagerList({
    params: {
      isPageable: false,
    },
  });

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {
    if (inputValues) {
      let variables = [];
      let headers = [];
      let queryParams = [];
      let apiResultToProcessVariable = [];

      if (inputValues?.variables) {
        variables = Object.keys(inputValues.variables).map((key) => {
          return {
            variableKey: key,
            variableValue: inputValues.variables[key],
          };
        });
      }

      if (inputValues?.headers) {
        headers = Object.keys(inputValues.headers).map((key) => {
          return {
            headerKey: key,
            headerValue: inputValues.headers[key],
          };
        });
      }

      if (inputValues?.queryParams) {
        queryParams = Object.keys(inputValues.queryParams).map((key) => {
          return {
            queryParamKey: key,
            queryParamValue: inputValues.queryParams[key],
          };
        });
      }

      if (inputValues?.apiResultToProcessVariable) {
        apiResultToProcessVariable = Object.keys(
          inputValues.apiResultToProcessVariable,
        ).map((key) => {
          return {
            apiResultKey: key,
            apiResultValue: inputValues.apiResultToProcessVariable[key],
          };
        });
      }

      setJsonConfig({
        url: inputValues?.url,
        method: inputValues?.method,
        apiManagerId: inputValues?.apiManagerId,
        body: inputValues?.body && unescape(inputValues.body),
        headers,
        queryParams,
        variables,
        apiResultId: inputValues?.apiResultId,
        apiResultToProcessVariable,
        useCustomConfig: inputValues?.useCustomConfig,
      });
    }
  }, [inputValues]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const validateConfig = (obj) => {
    const erros = [];

    if (obj.useCustomConfig) {
      if (!obj.url) {
        erros.push(language.urlRequired);
      }

      if (!obj.method) {
        erros.push(language.httpMethodRequired);
      }
    } else if (!obj.apiManagerId) {
      erros.push(language.apiRequired);
    }

    return erros;
  };

  const handleSave = () => {
    const url = jsonConfig?.url;
    const method = jsonConfig?.method;
    const apiManagerId = jsonConfig?.apiManagerId || null;
    const body = jsonConfig?.body && escape(jsonConfig.body);
    let headers = jsonConfig?.headers || [];
    let queryParams = jsonConfig?.queryParams || [];
    let variables = jsonConfig?.variables || [];
    const apiResultId = jsonConfig?.apiResultId;
    let apiResultToProcessVariable =
      jsonConfig?.apiResultToProcessVariable || [];
    const useCustomConfig = jsonConfig?.useCustomConfig;

    headers = headers.reduce((prev, current) => {
      if (current.headerKey) {
        prev[current.headerKey] = current.headerValue;
      }
      return prev;
    }, {});

    queryParams = queryParams.reduce((prev, current) => {
      if (current.queryParamKey) {
        prev[current.queryParamKey] = current.queryParamValue;
      }
      return prev;
    }, {});

    variables = variables.reduce((prev, current) => {
      if (current.variableKey) {
        prev[current.variableKey] = current.variableValue;
      }
      return prev;
    }, {});

    apiResultToProcessVariable = apiResultToProcessVariable.reduce(
      (prev, current) => {
        if (current.apiResultKey) {
          prev[current.apiResultKey] = current.apiResultValue;
        }
        return prev;
      },
      {},
    );

    const inputObject = {
      url,
      method,
      apiManagerId,
      body,
      headers,
      queryParams,
      variables,
      apiResultId,
      apiResultToProcessVariable,
      useCustomConfig,
    };

    const erros = validateConfig(inputObject);

    if (erros.length > 0) {
      setHasConfigError(erros);
    } else {
      //salvando no modeler
      saveIntegrarApiManagerConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  };

  const handleChangeConfigFields = (event) => {
    if (!event?.target) return;

    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeConfigFieldsCheckbox = (event) => {
    if (!event?.target) return;

    const { name, checked } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleChangeAutoCompleteConfigFields = (event, value, name) => {
    if (!event?.target) return;

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    setJsonConfig((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // ----- variable Methods
  const handleChangeApiVariables = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const variables = jsonConfig?.variables || [];

    variables[index] = {
      ...variables[index],
      [name]: value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      variables,
    }));
  };

  const addApiVariables = () => {
    const variables = jsonConfig?.variables || [];

    variables.push({
      variableKey: "",
      variableValue: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      variables,
    }));
  };

  const removeApiVariables = (event, index) => {
    const variables = jsonConfig?.variables || [];

    variables.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      variables,
    }));
  };

  const handleChangeAutoCompleteApiVariables = (event, value, index, name) => {
    if (!event?.target) return;

    const variables = jsonConfig?.variables || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    variables[index] = {
      ...variables[index],
      [name]: newValue,
    };

    setJsonConfig((prev) => ({
      ...prev,
      variables,
    }));
  };

  // ----- headers Methods
  const handleChangeApiHeaders = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const headers = jsonConfig?.headers || [];

    headers[index] = {
      ...headers[index],
      [name]: value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      headers,
    }));
  };

  const addApiHeaders = () => {
    const headers = jsonConfig?.headers || [];

    headers.push({
      headerKey: "",
      headerValue: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      headers,
    }));
  };

  const removeApiHeaders = (event, index) => {
    const headers = jsonConfig?.headers || [];

    headers.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      headers,
    }));
  };

  const handleChangeAutoCompleteApiHeaders = (event, value, index, name) => {
    if (!event?.target) return;

    const headers = jsonConfig?.headers || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    headers[index] = {
      ...headers[index],
      [name]: newValue,
    };

    setJsonConfig((prev) => ({
      ...prev,
      headers,
    }));
  };

  // ----- query params Methods
  const handleChangeApiQueryParams = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const queryParams = jsonConfig?.queryParams || [];

    queryParams[index] = {
      ...queryParams[index],
      [name]: value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      queryParams,
    }));
  };

  const addApiQueryParams = () => {
    const queryParams = jsonConfig?.queryParams || [];

    queryParams.push({
      queryParamKey: "",
      queryParamValue: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      queryParams,
    }));
  };

  const removeApiQueryParams = (event, index) => {
    const queryParams = jsonConfig?.queryParams || [];

    queryParams.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      queryParams,
    }));
  };

  const handleChangeAutoCompleteApiQueryParams = (
    event,
    value,
    index,
    name,
  ) => {
    if (!event?.target) return;

    const queryParams = jsonConfig?.queryParams || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    queryParams[index] = {
      ...queryParams[index],
      [name]: newValue,
    };

    setJsonConfig((prev) => ({
      ...prev,
      queryParams,
    }));
  };

  const handleChangeApiFormData = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const bodyFormData = jsonConfig?.bodyFormData || [];

    bodyFormData[index] = {
      ...bodyFormData[index],
      [name]: value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      bodyFormData,
    }));
  };

  const addApiFormData = () => {
    const bodyFormData = jsonConfig?.bodyFormData || [];

    bodyFormData.push({
      name: "",
      value: "",
      type: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      bodyFormData,
    }));
  };

  const removeApiFormData = (event, index) => {
    const bodyFormData = jsonConfig?.bodyFormData || [];

    bodyFormData.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      bodyFormData,
    }));
  };

  const handleChangeAutoCompleteApiFormData = (event, value, index, name) => {
    if (!event?.target) return;

    const bodyFormData = jsonConfig?.bodyFormData || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    bodyFormData[index] = {
      ...bodyFormData[index],
      [name]: newValue,
    };

    setJsonConfig((prev) => ({
      ...prev,
      bodyFormData,
    }));
  };

  // -------- result to process methods
  const handleChangeApiResultToProcess = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const apiResultToProcessVariable =
      jsonConfig?.apiResultToProcessVariable || [];

    apiResultToProcessVariable[index] = {
      ...apiResultToProcessVariable[index],
      [name]: value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      apiResultToProcessVariable,
    }));
  };

  const addApiResultToProcess = () => {
    const apiResultToProcessVariable =
      jsonConfig?.apiResultToProcessVariable || [];

    apiResultToProcessVariable.push({
      apiResultKey: "",
      apiResultValue: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      apiResultToProcessVariable,
    }));
  };

  const removeApiResultToProcess = (event, index) => {
    const apiResultToProcessVariable =
      jsonConfig?.apiResultToProcessVariable || [];

    apiResultToProcessVariable.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      apiResultToProcessVariable,
    }));
  };

  const handleChangeAutoCompleteApiResultToProcess = (
    event,
    value,
    index,
    name,
  ) => {
    if (!event?.target) return;

    const apiResultToProcessVariable =
      jsonConfig?.apiResultToProcessVariable || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    apiResultToProcessVariable[index] = {
      ...apiResultToProcessVariable[index],
      [name]: newValue,
    };

    setJsonConfig((prev) => ({
      ...prev,
      apiResultToProcessVariable,
    }));
  };

  // ----- select api manager
  const handleChangeApiManager = (event) => {
    const { value } = event.target;

    let body = jsonConfig?.body;
    if (jsonConfig?.useCustomConfig) {
      const selectedApiManager = apiManagerList?.content?.find(
        (item) => String(item.id) === String(value),
      );
      const selectedApiManagerBody = selectedApiManager?.body || "";

      if (selectedApiManagerBody) {
        body = selectedApiManagerBody;
      }
    }

    setJsonConfig((prev) => ({
      ...prev,
      apiManagerId: String(value),
      body,
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <Provider>
        <GenericModal
          title={language.configuration}
          handleClose={handleClose}
          size={state.maxWidth}
          bigHeight
          open={true}
          handleSubmit={handleSave}
          btnActionTitle={language.save}
          btnCancelTitle={language.cancel}
          overrideDialogActions={() =>
            OverrideModalActions({
              handleSubmit: handleSave,
              handleClose,
            })
          }
        >
          <Tabs
            value={tabValue}
            indicatorColor="secondary"
            textColor="secondary"
            onChange={handleChangeTab}
          >
            <Tab label={language.properties} />
            <Tab label={language.configuration} disabled />
            <Tab label={language.permissions} disabled />
          </Tabs>

          <FormPadding>
            <TabPanel value={tabValue} index={0}>
              <Grid container spacing={3}>
                <TabProperties
                  businessObject={businessObject}
                  taskFields={FormComponents}
                  jsonConfig={jsonConfig}
                  handleChangeApiManager={handleChangeApiManager}
                  handleChangeApiVariables={handleChangeApiVariables}
                  addApiVariables={addApiVariables}
                  removeApiVariables={removeApiVariables}
                  handleChangeAutoCompleteApiVariables={
                    handleChangeAutoCompleteApiVariables
                  }
                  handleChangeApiResultToProcess={
                    handleChangeApiResultToProcess
                  }
                  addApiResultToProcess={addApiResultToProcess}
                  removeApiResultToProcess={removeApiResultToProcess}
                  handleChangeAutoCompleteApiResultToProcess={
                    handleChangeAutoCompleteApiResultToProcess
                  }
                  handleChangeApiHeaders={handleChangeApiHeaders}
                  addApiHeaders={addApiHeaders}
                  removeApiHeaders={removeApiHeaders}
                  handleChangeAutoCompleteApiHeaders={
                    handleChangeAutoCompleteApiHeaders
                  }
                  handleChangeApiQueryParams={handleChangeApiQueryParams}
                  addApiQueryParams={addApiQueryParams}
                  removeApiQueryParams={removeApiQueryParams}
                  handleChangeAutoCompleteApiQueryParams={
                    handleChangeAutoCompleteApiQueryParams
                  }
                  handleChangeApiFormData={handleChangeApiFormData}
                  addApiFormData={addApiFormData}
                  removeApiFormData={removeApiFormData}
                  handleChangeAutoCompleteApiFormData={
                    handleChangeAutoCompleteApiFormData
                  }
                  handleChangeConfigFields={handleChangeConfigFields}
                  handleChangeAutoCompleteConfigFields={
                    handleChangeAutoCompleteConfigFields
                  }
                  handleChangeConfigFieldsCheckbox={
                    handleChangeConfigFieldsCheckbox
                  }
                  apiManagerList={apiManagerList}
                />
              </Grid>
            </TabPanel>
          </FormPadding>

          {hasConfigError && (
            <GenericSnackbar
              errorWithChildren={true}
              message={
                <div>
                  {hasConfigError.map((err, index) => {
                    return <div key={`errorMessage_${index}`}>{err}</div>;
                  })}
                </div>
              }
              handleClose={() => setHasConfigError(false)}
              duration={4000}
            />
          )}
        </GenericModal>
      </Provider>
    )
  );
}

export default ModelerIntegrarApiManager;
